import { handleRequest } from './base';

const lookupRepo = {
  url: (url) => handleRequest({
    method: 'get',
    url: `/lookup?url=${url}`,
  }),

  bulkUrlLookup: async (urls) => {
    const { data: { gws } } = await handleRequest({
      method: 'post',
      url: '/lookup',
      data: { urls },
    });
    return gws;
  },
};

export { lookupRepo };
